import React from "react";
import TopNavbar from "../../../Shared/TopNavbar";
import Footer from "../../../Shared/Footer";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
const QaAutomation = () => {
  return (
    <>
      <TopNavbar title={"Home"} />
      <div class="success_stories-template success_stories-template-success_stories-template success_stories-template-success_stories-template-php single single-success_stories postid-166 wp-embed-responsive">
        <div class="wrap ">
          <div id="site-content" class="content-area">
            <main id="main" class="site-main" role="main">
              <section class="success-banner">
                <div class="img-wrap">
                  <noscript>
                    <img
                      width="1920"
                      height="743"
                      src="sp-ao.shortpixel.ai/client/to_webp%2cq_glossy%2cret_img%2cw_1920%2ch_743/https_/www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-%e2%80%93-Helping-the-client-incorporateNW.png"
                      class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                      alt=""
                      srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1920/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW.png 1920w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-300x116.png 300w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1024/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-1024x396.png 1024w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_768/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-768x297.png 768w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1536/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-1536x594.png 1536w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_24/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-24x9.png 24w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_36/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-36x14.png 36w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_48/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-48x19.png 48w"
                      sizes="(max-width: 1920px) 100vw, 1920px"
                    />
                  </noscript>
                  <img
                    width="1920"
                    height="743"
                    src="wp-content/uploads/2020/08/Success-Stories-Banner-Image-%e2%80%93-Helping-the-client-incorporateNW.png"
                    // data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1920,h_743/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW.png"
                    class="lazyload attachment-post-thumbnail size-post-thumbnail wp-post-image"
                    alt=""
                    //data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1920/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW.png 1920w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-300x116.png 300w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1024/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-1024x396.png 1024w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_768/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-768x297.png 768w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1536/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-1536x594.png 1536w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_24/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-24x9.png 24w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_36/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-36x14.png 36w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_48/https://www.fugetroncorp.com/wp-content/uploads/2020/08/Success-Stories-Banner-Image-–-Helping-the-client-incorporateNW-48x19.png 48w"
                    // data-sizes="(max-width: 1920px) 100vw, 1920px"
                  />{" "}
                </div>
                <div class="wrapper">
                  <h2>QA Automation</h2>
                  <a href="#" title="Case Study" target="">
                    Case Study
                  </a>
                  <p>
                    Helping the Client incorporate automation testing within
                    their manual testing Framework.
                  </p>
                </div>
              </section>

              <section
                class="lazyload success-tab"
                data-bg="wp-content/uploads/2021/10/Homepage-Our-Comapny-section.png"
              >
                <div class="wrapper">
                  <div class="intro-content common-content">
                    <p>
                      Implementing Automated testing framework in to an existing
                      Manuel workflow using Mirco-Focus UFT
                    </p>
                  </div>
                  <Tabs>
                    <div class="tab-link">
                      <TabList>
                        <Tab>
                          <div>
                            <span class="img-wrap">
                              <noscript>
                                <img
                                  src="img/overview-dark.png"
                                  alt="Overview"
                                />
                              </noscript>
                              <img
                                class="lazyload"
                                src="img/overview-dark.png"
                                // data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/overview-dark.png"
                                alt="Overview"
                              />
                              <noscript>
                                <img
                                  src="img/overview-white.png"
                                  class="active"
                                  alt="Overview"
                                />
                              </noscript>
                              <img
                                src="img/overview-white.png"
                                //data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/overview-white.png"
                                class="lazyload active"
                                alt="Overview"
                              />
                            </span>
                            Overview
                          </div>
                        </Tab>
                        <Tab>
                          <div>
                            <span class="img-wrap">
                              <noscript>
                                <img
                                  src="img/challenge-dark.png"
                                  alt="The Challenge"
                                />
                              </noscript>
                              <img
                                class="lazyload"
                                src="img/challenge-dark.png"
                                //data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/challenge-dark.png"
                                alt="The Challenge"
                              />
                              <noscript>
                                <img
                                  src="img/challenge-white.png"
                                  class="active"
                                  alt="The Challenge"
                                />
                              </noscript>
                              <img
                                src="img/challenge-white.png"
                                //data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/challenge-white.png"
                                class="lazyload active"
                                alt="The Challenge"
                              />
                            </span>
                            The Challenge
                          </div>
                        </Tab>
                        <Tab>
                          <div>
                            <span class="img-wrap">
                              <noscript>
                                <img
                                  src="img/solution-dark.png"
                                  alt="The Solution"
                                />
                              </noscript>
                              <img
                                class="lazyload"
                                src="img/solution-dark.png"
                                // data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/solution-dark.png"
                                alt="The Solution"
                              />
                              <noscript>
                                <img
                                  src="img/solution-white.png"
                                  class="active"
                                  alt="The Solution"
                                />
                              </noscript>
                              <img
                                src="img/solution-white.png" // data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2020/08/solution-white.png"
                                class="lazyload active"
                                alt="The Solution"
                              />
                            </span>
                            The Solution
                          </div>
                        </Tab>
                      </TabList>
                    </div>

                    <div class="tab-content common-content">
                      <TabPanel>
                        <div data-attr="overview">
                          <p>
                            <strong>Overview:</strong>
                            <br />
                            Although manual testing will never go away 100%,
                            automation testing can be incorporated in many
                            cases. Automation testing not only saves time and
                            effort but it also improves the testing accuracy and
                            can simulate hundreds if not thousands of testers.
                            With this in mind, Fugetron helped incorporate
                            Automation testing framework using Micro-Focus UFT.
                          </p>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div data-attr="thechallenge">
                          <p>
                            <strong>The Challenge:</strong>
                            <br />
                            Majority of the Client’s testing on their legacy
                            green screen applications was manual. Manual testing
                            meant they required more resources and spent more
                            time on their testing while still having an immense
                            backlog to work through.
                          </p>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div data-attr="thesolution">
                          <p>
                            <strong>The Solution:</strong>
                            <br />
                            Fugetron Corp. stepped in to implement QA automation
                            for the Client employing a Hybrid framework along
                            with Micro-Focus UFT, which was most compatible with
                            the Client’s legacy applications. Our offshore QA
                            team lead by an Onsite Automation Architect began
                            creating Base Framework scripts for the different
                            apps that would employ the framework. Most testing
                            scenarios completed were then uploaded onto
                            BitBucket to be utilized by the Client’s dev ops
                            cycles.
                          </p>
                          <p>
                            Fugetron Corp. not only helped to implement QA
                            automation but also built an offshore QA team for
                            the Client to be able to achieve the “Follow the
                            Sun” model for their projects. The Client is now
                            able to complete their work essentially around the
                            clock with increased productivity at an affordable
                            cost.
                          </p>
                        </div>{" "}
                      </TabPanel>
                    </div>
                  </Tabs>

                  <div class="conclusion-content common-content"></div>
                </div>
              </section>
            </main>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default QaAutomation;
